import { Auth } from "aws-amplify";
import { useRouter } from "routes/hooks/useRouter";
import { BiLogOut } from "react-icons/bi";
import { TokenManager } from "utils/tokenManager";

export const Logout = (props: {}): JSX.Element => {
  const router = useRouter();
  const isImpersonating = TokenManager.isImpersonating();

  const handleLogout = async () => {
    if (isImpersonating) return;
    try {
      await Auth.signOut();

      localStorage.clear();

      router.push("/auth/sign-in");
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  return (
    <div
      className="my-[15px] flex cursor-pointer items-center pb-1 pt-1 hover:!text-white"
      onClick={(e) => {
        e.preventDefault();
        handleLogout();
      }}
    >
      <BiLogOut className="h-6 w-6 mr-2 menu-text-color" />
      <p className="leading-1 !font-medium text-gray-600">Sign Out</p>
    </div>
  );
};

export default Logout;
